import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: { offlineAvailability: true },
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/",
      name: "dashboard",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/reporting",
      name: "reporting",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "reporting" */ "../views/Reporting.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/reporting/:report_id",
      name: "reportingView",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "reportingView" */ "../views/Reporting.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/merging",
      name: "merging",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "merging" */ "../views/MergeSurveys.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/users",
      name: "users",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "users" */ "../views/Users.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/your-profile",
      name: "your-profile",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "your-profile" */ "../views/UserProfile.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/contact",
      name: "contact",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "contact" */ "../views/Contact.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/surveys",
      name: "surveys",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "surveys" */ "../views/Surveys.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/surveys/:surveys_id",
      name: "surveysView",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "surveysView" */ "../views/Surveys.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/organizations",
      name: "organizations",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "organizations" */ "../views/Organizations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/map-test",
      name: "map-test",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "map-test" */ "../views/MapTest.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/trailers",
      name: "trailers",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "trailers" */ "../views/Trailers.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/scan-reprocess",
      name: "scan-reprocess",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "scan-reprocess" */ "../views/ScanReprocessing.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/settings",
      name: "settings",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "settings" */ "../views/Settings.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/mobile-view",
      name: "mobile-view",
      component: () =>
        import(/* webpackChunkName: "mobile-view" */ "../views/MobileView.vue"),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "home",
          name: "mobile-view-home",
          meta: { offlineAvailability: true, pwa: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-home" */ "../views/mobileView/Home.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "scheduled-mp-surveys",
          name: "mobile-view-scheduled-mp-surveys",
          meta: { offlineAvailability: true, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-scheduled-mp-surveys" */ "../views/mobileView/ScheduledMpSurveys"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "past-surveys",
          meta: { offlineAvailability: false, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "past-surveys" */ "../views/mobileView/PastSurveys.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "map-past-surveys",
          meta: { offlineAvailability: false, pwa: true },
          component: () =>
            import(
              /* webpackChunkName: "map-past-surveys" */ "../views/mobileView/MapPastSurveySelect.vue"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "mp-survey",
          name: "mobile-view-mp-survey",
          meta: { offlineAvailability: true, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-mp-survey" */ "../views/mobileView/MpSurvey"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "mp-survey/:id",
          name: "mobile-view-mp-survey-id",
          meta: { offlineAvailability: true, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-mp-survey-id" */ "../views/mobileView/MpSurvey"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "upload-data",
          name: "mobile-view-upload-Data",
          meta: { offlineAvailability: true, pwa: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-upload-Data" */ "../views/mobileView/UploadData"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "contact",
          name: "mobile-view-contact",
          meta: { offlineAvailability: true, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-contact" */ "../views/mobileView/Contact"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "settings",
          name: "mobile-view-settings",
          meta: { offlineAvailability: true, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-settings" */ "../views/mobileView/Settings"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "controller",
          name: "mobile-view-device-controller",
          meta: { offlineAvailability: true, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-settings" */ "../views/mobileView/DeviceController"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "user-profile",
          name: "mobile-view-user-profile",
          meta: { offlineAvailability: false, pwa: true, whiteMenu: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-user-profile" */ "../views/mobileView/UserProfile"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "survey-mp-report",
          name: "mobile-view-survey-mp-report",
          meta: { offlineAvailability: true, pwa: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-survey-mp-report" */ "../views/mobileView/SurveyMPReport"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "survey-mp-report/:id",
          name: "mobile-view-survey-mp-report-specific",
          meta: { offlineAvailability: true, pwa: true },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-survey-mp-report-specific" */ "../views/mobileView/SurveyMPReport"
            )
        },
        {
          beforeEnter: AuthGuard,
          path: "survey-progress",
          name: "mobile-view-survey-progress",
          meta: {
            offlineAvailability: true,
            pwa: true,
            backButtonDisabled: true
          },
          component: () =>
            import(
              /* webpackChunkName: "mobile-view-survey-progress" */ "../views/mobileView/SurveyInProgress"
            )
        }
      ]
    }
  ]
});
